import { Group, TextInput, rem } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { useDebouncedCallback } from "use-debounce";

interface UsersSearchFilterProps {
  onUpdateName?: (name: string) => void;
}

export const UsersSearchFilter = (props: UsersSearchFilterProps) => {
  const { onUpdateName } = props;

  const debouncedTitle = useDebouncedCallback(
    (value) => {
      onUpdateName && onUpdateName(value);
    },
    // delay in ms
    500
  );

  return (
    <Group>
      <TextInput
        label=""
        placeholder="name"
        leftSection={<IconSearch style={{ width: rem(16), height: rem(16) }} />}
        onChange={(user) => debouncedTitle(user.currentTarget.value)}
      />
    </Group>
  );
};
